// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var englishTranslation = {
    translations: {
        common: {
            goBack: "Go back",
            showMore: "Show More",
            showLess: "Show Less",
        },
        a11y: {
            skipToContent: "Skip to main content",
            helpAbout: "Help about {{topic}}",
            copyToClipboard: "Copy {{label}} to clipboard",
            previewMaterial: "Preview {{title}}",
            ballotsTable: "Ballots",
            ballotLocatorTabs: "Ballot locator sections",
            ballotIdLabel: "Ballot ID",
            votingProgress: "Voting progress",
            stepOf: "Step {{current}} of {{total}}",
            selectUpTo_one: "Select up to {{count}} option",
            selectUpTo_many: "Select up to {{count}} options",
            selectUpTo_other: "Select up to {{count}} options",
            selectExactly_one: "Select {{count}} option",
            selectExactly_many: "Select {{count}} options",
            selectExactly_other: "Select {{count}} options",
            selectBetween: "Select between {{min}} and {{max}} options",
        },
        candidatesList: {
            collapseToggle: "Toggle list {{listTitle}}",
            showCandidates: "Show candidates",
            hideCandidates: "Hide candidates",
            selectedCandidates_one: "{{count}} candidate selected",
            // `_many` is selected only in es/cat/fr, for exact multiples of a million. English never
            // selects it, but the other bundles are typed `TranslationType = typeof englishTranslation`,
            // so the key has to be declared here before they can carry it.
            selectedCandidates_many: "{{count}} candidates selected",
            selectedCandidates_other: "{{count}} candidates selected",
            expandAll: "Expand all",
            collapseAll: "Collapse all",
        },
        breadcrumbSteps: {
            electionList: "Ballot List",
            ballot: "Ballot",
            review: "Review",
            confirmation: "Confirmation",
            audit: "Audit",
        },
        footer: {
            poweredBy: "Powered by <1></1>",
        },
        contest: {
            acclamation: {
                description: "This contest was decided by acclamation. Its candidates are elected without a vote, so no option can be selected and no vote is recorded for it.",
            },
        },
        votingScreen: {
            backButton: "Back",
            reviewButton: "Next",
            clearButton: "Clear selections",
            ballotHelpDialog: {
                title: "Information: Ballot screen",
                content: "This screen shows the contests you are eligible to vote in. You can make your selection by activating the checkbox to the right of the Candidate/Answer. To reset your selections, click the “<b>Clear selections</b>” button; to move to the next step, click the “<b>Next</b>” button below.",
                ok: "OK",
            },
            nonVotedDialog: {
                title: "Invalid or blank vote",
                content: "Some of your answers will render the ballot in one or more contests invalid or blank.",
                ok: "Back and review",
                continue: "Continue",
                cancel: "Cancel",
            },
            warningDialog: {
                title: "Review your ballot",
                content: "Your ballot contains selections that may need your attention (such as selecting fewer options than allowed). Your ballot is valid and will be counted as submitted.",
                ok: "Back and review",
                continue: "Continue",
                cancel: "Cancel",
            },
            blankBallotDialog: {
                title: "You have not selected any candidates",
                content: "You have not made any selections. Your ballot will be cast as a blank ballot, which is a valid, deliberate choice and will be counted as such.",
                continue: "Continue",
                cancel: "Cancel",
            },
        },
        startScreen: {
            startButton: "Start Voting",
            declineToVoteButton: "Decline to Vote",
            declineToVoteDialog: {
                title: "Confirm decline to vote",
                content: "Are you sure you want to decline to vote?<br />You will go directly to review and your participation status will be saved as <b>Declined to vote</b>.",
                continue: "Decline to vote",
                cancel: "Cancel",
            },
            instructionsTitle: "Instructions",
            instructionsDescription: "Please follow these steps to cast your ballot:",
            step1Title: "1. Make your selections",
            step1Description: "Choose your preferred candidates and make your selections in each contest as it appears. You can edit your ballot until you are ready to proceed.",
            step2Title: "2. Review your ballot",
            step2Description: "Once you are satisfied with your selections, we will encrypt your ballot and show you a final review of your choices. You will also receive a unique tracker ID for your ballot.",
            step3Title: "3. Cast your ballot",
            step3Description: "Cast your ballot: Finally, you can cast your ballot so it is properly registered. Alternatively, you can opt to audit and confirm that your ballot was correctly captured and encrypted.",
        },
        reviewScreen: {
            acclamation: {
                title: "Decided by acclamation",
                helpDialog: {
                    title: "Information: Acclamation",
                    content: "This screen shows what was decided by acclamation. Because no option could be selected, no ballot is cast and there is nothing to verify afterwards.",
                    ok: "OK",
                },
                description: "Review what was decided by acclamation in this election. No ballot will be cast.",
                finishButton: "Finish",
            },
            title: "Review your ballot",
            description: "To make changes in your selections, click “<b>Edit ballot</b>” button, to confirm your selections, click “<b>Cast your ballot</b>” button below, and to audit your ballot click the “<b>Audit Ballot</b>” button below.",
            descriptionNoAudit: "To make changes in your selections, click “<b>Edit ballot</b>” button, to confirm your selections, click “<b>Cast your ballot</b>” button below.",
            backButton: "Edit ballot",
            castBallotButton: "Cast your ballot",
            auditButton: "Audit ballot",
            copyBallotId: "Copy ballot ID",
            ballotIdCopied: "Ballot ID copied",
            ballotIdCopyError: "Could not copy ballot ID",
            reviewScreenHelpDialog: {
                title: "Information: Review Screen",
                content: "This screen allows you to review your selections before casting your ballot.",
                ok: "OK",
            },
            ballotIdHelpDialog: {
                title: "Vote has not been cast",
                content: "<p>This is your Ballot Tracker ID, but <b>your vote has not been cast yet</b>. If you try to track the ballot, you will not find it.</p><p>The reason we show the Ballot Tracker ID at this stage is to allow you to audit the correctness of the encrypted ballot before casting it.</p>",
                ok: "I accept my vote has NOT been cast",
                cancel: "Cancel",
            },
            auditBallotHelpDialog: {
                title: "Do you want to audit the ballot?",
                content: "<p>Please note that auditing your ballot will void it, requiring you to restart the voting process. The audit process lets you verify that your ballot is correctly encoded, but it involves advanced technical steps. We recommend proceeding only if you are confident in your technical skills. If you just want to cast your ballot, click <u>Cancel</u> to go back to the review ballot screen.</p>",
                ok: "Yes, I want to DISCARD my ballot to audit it",
                cancel: "Cancel",
            },
            confirmCastVoteDialog: {
                title: "Are you sure you want to cast your vote?",
                content: "Your vote will no longer be editable once confirmed.",
                ok: "Yes, I want to CAST my vote",
                cancel: "Cancel",
            },
            confirmCastBlankBallotDialog: {
                title: "Are you sure you want to cast a blank ballot?",
                content: "You have not selected any candidates. After you confirm, your ballot will be cast as blank.",
                ok: "Yes, cast my blank ballot",
                cancel: "Cancel",
            },
            unfilledContestsDialog: {
                title: "Some selections are unfilled",
                content: "You may leave an office blank or select fewer candidates. Check the following before continuing.",
                selected: "{{selected}} of {{max}} selected",
                nothingSelected: "No vote for this office",
                ok: "Continue with these selections",
                cancel: "Review selections",
            },
            error: {
                NETWORK_ERROR: "There was a network problem. Please try again later or contact support for assistance.",
                UNABLE_TO_FETCH_DATA: "There was a problem fetching the data. Please try again later or contact support for assistance.",
                LOAD_ELECTION_EVENT: "Cannot load election event. Please try again later.",
                CAST_VOTE: "There was an unknown error while casting the vote. Please try again later or contact support for assistance.",
                CAST_VOTE_AreaNotFound: "There was an error while casting the vote: Area not found. Please try again later or contact support for assistance.",
                CAST_VOTE_CheckStatusFailed: "Election does not allow casting the vote. Election might be closed, archived or you might be trying to vote outside grace period.",
                CAST_VOTE_InternalServerError: "An internal error occurred while casting the vote. Please try again later or contact support for assistance.",
                CAST_VOTE_QueueError: "There was a problem processing your vote. Please try again later or contact support for assistance.",
                CAST_VOTE_Unauthorized: "You are not authorized to cast a vote. Please contact support for assistance.",
                CAST_VOTE_ElectionEventNotFound: "The election event could not be found. Please try again later or contact support for assistance.",
                CAST_VOTE_ElectoralLogNotFound: "Your voting record could not be found. Please contact support for assistance.",
                CAST_VOTE_CheckPreviousVotesFailed: "An error occurred while checking your voting status. Please try again later or contact support for assistance.",
                CAST_VOTE_GetClientCredentialsFailed: "Failed to verify your credentials. Please try again later or contact support for assistance.",
                CAST_VOTE_GetAreaIdFailed: "An error occurred verifying your voting area. Please try again later or contact support for assistance.",
                CAST_VOTE_GetTransactionFailed: "An error occurred processing your vote. Please try again later or contact support for assistance.",
                CAST_VOTE_DeserializeBallotFailed: "An error occurred reading your ballot. Please try again later or contact support for assistance.",
                CAST_VOTE_DeserializeContestsFailed: "An error occurred reading your selections. Please try again later or contact support for assistance.",
                CAST_VOTE_PokValidationFailed: "Failed to validate your vote. Please try again later or contact support for assistance.",
                CAST_VOTE_UuidParseFailed: "An error occurred processing your request. Please try again later or contact support for assistance.",
                CAST_VOTE_unexpected: "An unknown error occurred while casting the vote. Please try again later or contact support for assistance.",
                CAST_VOTE_timeout: "Timeout error to cast the vote. Please try again later or contact support for assistance.",
                CAST_VOTE_InsertFailedExceedsAllowedRevotes: "You have exceeded the revotes limit. Please try again later or contact support for assistance.",
                CAST_VOTE_CheckRevotesFailed: "You have exceeded the allowed number of revotes. Please try again later or contact support for assistance.",
                CAST_VOTE_CheckVotesInOtherAreasFailed: "You have voted in another area already. Please try again later or contact support for assistance.",
                CAST_VOTE_UnknownError: "An unknown error occurred while casting the vote. Please try again later or contact support for assistance.",
                NO_BALLOT_SELECTION: "The selection state for this election is not present. Please ensure you have made your selections correctly or contact support.",
                NO_BALLOT_STYLE: "The ballot style is not available. Please contact support.",
                NO_AUDITABLE_BALLOT: "No auditable ballot is available. Please contact support.",
                INCONSISTENT_HASH: "There was an error related to the ballot hashing process. BallotId: {{ballotId}} is not consistent with auditable Ballot Hash: {{auditableBallotHash}}. Please report this issue to support.",
                ELECTION_EVENT_NOT_OPEN: "The election event is closed. Please contact support.",
                PARSE_ERROR: "There was an error parsing the ballot. Please try again later or contact support for assistance.",
                DESERIALIZE_AUDITABLE_ERROR: "There was an error deserializing the auditable ballot. Please try again later or contact support for assistance.",
                DESERIALIZE_HASHABLE_ERROR: "There was an error deserializing the hashable ballot. Please try again later or contact support for assistance.",
                CONVERT_ERROR: "There was an error converting the ballot. Please try again later or contact support for assistance.",
                SERIALIZE_ERROR: "There was an error serializing the ballot. Please try again later or contact support for assistance.",
                UNKNOWN_ERROR: "There was an error. Please try again later or contact support for assistance.",
                REAUTH_FAILED: "Authentication failed. Please try again or contact support for assistance.",
                SESSION_EXPIRED: "Your session has expired. Please try again from the beginning.",
                CAST_VOTE_BallotIdMismatch: "The ballot id does not match with the cast vote.",
                SESSION_STORAGE_ERROR: "Session storage is not available. Please try again or contact support.",
                PARSE_BALLOT_DATA_ERROR: "There was an error parsing the ballot data. Please try again later or contact support for assistance.",
                NOT_VALID_BALLOT_DATA_ERROR: "Ballot data is not valid. Please try again later or contact support for assistance.",
                FETCH_DATA_TIMEOUT_ERROR: "Timeout error to fetch the data. Please try again later or contact support for assistance.",
                TO_HASHABLE_BALLOT_ERROR: "Error converting to hashable ballot. Please try again later or contact support for assistance.",
                INTERNAL_ERROR: "There was an internal error while casting the vote. Please try again later or contact support for assistance.",
            },
            declineToVote: "Decline to vote",
            blankBallot: "Blank ballot",
        },
        confirmationScreen: {
            acclamation: {
                title: "Decided by acclamation",
                description: "Every contest in this election was decided by acclamation, so no ballot was cast and there is no ballot ID to track.",
                helpDialog: {
                    title: "Information: Acclamation",
                    content: "Every contest in this election was decided by acclamation: its candidates are elected without a vote. Because no ballot was cast, there is no ballot ID, receipt or QR code to verify.",
                    ok: "OK",
                },
            },
            title: "Your vote has been cast",
            description: "The confirmation code below verifies that <b>your ballot has been cast successfully</b>. You can use this code to verify that your ballot has been counted.",
            blankBallot: {
                description: "Your ballot was cast blank, which is a valid, deliberate choice.",
            },
            ballotId: "Ballot ID",
            printButton: "Print",
            finishButton: "Finish",
            remainingElectionsError: "We couldn’t check whether you have more elections to vote in. Please retry.",
            retryButton: "Retry",
            verifyCastTitle: "Verify that your ballot has been cast",
            verifyCastDescription: "You can verify your ballot has been cast correctly at any moment using the following QR code:",
            confirmationHelpDialog: {
                title: "Information: Confirmation Screen",
                content: "This screen shows that your vote was successfully cast. The information provided on this page allows you to verify that the ballot has been stored in ballot box , this process can be executed at any time during voting period and after the Ballot has been closed.",
                ok: "OK",
            },
            demoPrintDialog: {
                title: "Printing ballot",
                content: "Printing disabled in demo mode",
                ok: "OK",
            },
            demoBallotUrlDialog: {
                title: "Ballot Id",
                content: "Cannot use code, disabled in demo mode.",
                ok: "OK",
            },
            ballotIdHelpDialog: {
                title: "Information: Ballot ID",
                content: "The Ballot ID is a code that allows you to find your ballot in the ballot box, this ID is unique and doesn't contain information about your selections.",
                ok: "OK",
            },
            ballotIdDemoHelpDialog: {
                title: "Information: Ballot ID",
                content: "<p>The Ballot ID is a code that allows you to find your ballot in the ballot box, this ID is unique and doesn't contain information about your selections.</p><p><b>Notice:</b> This voting booth is for demonstration purposes only. Your vote has NOT been cast.</p>",
                ok: "OK",
            },
            errorDialogPrintBallotReceipt: {
                title: "Error",
                content: "An error has occured, please try again",
                ok: "OK",
            },
            demoQRText: "Ballot tracker is disabled in demo mode",
        },
        auditScreen: {
            printButton: "Print",
            restartButton: "Start Voting",
            title: "Audit your Ballot",
            description: "To verify your ballot, please follow the steps below:",
            step1Title: "1. Download or copy the following information",
            step1Description: "Your <b>Ballot ID</b> that appears at the top of the screen and your encrypted ballot below:",
            step1HelpDialog: {
                title: "Copy the Encrypted Ballot",
                content: "You can download or copy your encrypted ballot to audit the ballot and verify the encrypted content contains your selections.",
                ok: "OK",
            },
            downloadButton: "Download",
            step2Title: "2. Verify your ballot",
            step2Description: "<VerifierLink>Access to the ballot verifier</VerifierLink>, a new tab will open in your browser.",
            step2HelpDialog: {
                title: "Audit ballot tutorial",
                content: "To audit your ballot you will need to follow the steps shown in the tutorial, this includes the download of a desktop application used to verify the encrypted ballot independently from the website.",
                ok: "OK",
            },
            bottomWarning: "For security reasons, when you audit your ballot, it needs to be spoiled. To continue with the voting process, you need to click ‘<b>Start Voting</b>’ below.",
        },
        electionSelectionScreen: {
            title: "Ballot list",
            description: "Select the ballot you want to vote on",
            chooserHelpDialog: {
                title: "Information: Ballot List",
                content: "Welcome to the Voting Booth. This screen shows the ballots you can vote on. Ballots displayed in this list can be open to voting, scheduled, or closed. You will be able to access the ballot only if the voting period is open.",
                ok: "OK",
            },
            noResults: "No ballots for now.",
            resultsButton: "View results",
            demoDialog: {
                title: "Demo voting booth",
                content: "You are entering a demo voting booth. <strong>Your vote will NOT be cast.</strong> This voting booth is for demonstration purposes only.",
                ok: "I accept my vote will Not be cast",
            },
            errors: {
                noVotingArea: "Election area not assigned to voter. Please try again later or contact support for assistance.",
                networkError: "There was a network problem. Please try again later or contact support for assistance.",
                unableToFetchData: "There was a problem fetching the data. Please try again later or contact support for assistance.",
                noElectionEvent: "Election event doesn’t exist. Please try again later or contact support for assistance.",
                ballotStylesEmlError: "There was an error with the publish ballot style. Please try again later or contact support for assistance.",
                obtainingElectionFromID: "There was an error obtaining elections associated with the following election IDs: {{electionIds}}. Please try again later or contact support for assistance.",
            },
            alerts: {
                noElections: "There are no elections you can vote for. This could be because the area doesn’t have any contest associated. Please try again later or contact support for assistance.",
                electionEventNotPublished: "The election event hasn’t been published yet. Please try again later or contact support for assistance.",
            },
            materialsGate: {
                instructions: "You must read the <MaterialsLink>{{materialsTitle}}</MaterialsLink> before you can vote.",
            },
        },
        errors: {
            page: {
                oopsWithStatus: "Oops! {{status}}",
                oopsWithoutStatus: "Oops! Unexpected Error",
                somethingWrong: "Something went wrong.",
                certAuthFailedTitle: "Certificate Authentication Failed",
                certAuthFailedMessage: "Your certificate could not be verified. Please check that you are using a valid voter certificate and try again.",
                invalidLoginHintParametersTitle: "Invalid voting link",
                invalidLoginHintParametersMessage: "This voting link contains invalid login information. Request a new link and try again.",
            },
        },
        materials: {
            common: {
                label: "Support Materials",
                back: "Back to Ballot List",
                close: "Close",
                preview: "Preview",
                download: "Download",
            },
            mandatory: {
                checkboxLabel: "I have read the Support Materials",
                continueButton: "Continue",
                error: "There was a problem recording your acknowledgment. Please try again.",
            },
        },
        slates: {
            title: "Slates",
            independent: "Independent",
            contestMembers: "{{slate}} candidates for {{contest}}",
            noCandidate: "No candidate",
            note: "A slate selects its candidates and leaves offices without a slate candidate blank. You can change individual choices at any time.",
            coverage: {
                full: "Full slate",
                singleContest: "{{contest}} only",
                partial: "Partial slate",
                everyOffice: "Candidates for every office.",
                someOffices: "Candidates for {{offices}}. Other offices are left blank.",
                candidates_one: "{{count}} candidate",
                candidates_other: "{{count}} candidates",
                offices_one: "{{count}} office",
                offices_other: "{{count}} offices",
            },
            candidateList: {
                show: "Show candidates",
                hide: "Hide candidates",
            },
            tabs: {
                label: "Selection method",
                slates: "Choose a slate",
                candidates: "Individual candidates",
            },
            count: {
                short: "{{selected}} / {{seats}} candidates selected",
                long: "· {{selected}} of {{seats}} candidates selected",
                individual: "Individual selections",
                none: "No candidates selected",
            },
            allSelections: {
                label: "Your current selections",
                none: "No selection",
            },
            review: {
                title: "Your selections",
                of: "of {{seats}}",
                selected: "Candidates selected",
                note: "Your vote is recorded for each selected candidate.",
                contestCount: "{{selected}} of {{max}} selected",
                unfilled: "No candidate selected",
                editLabel: "Edit {{contest}}",
            },
            selection: {
                all: "All {{total}} selected",
                mixed: "Mixed · {{selected}} of {{total}} selected",
                partly: "Partly selected · {{selected}} of {{total}}",
                selected: "Selected",
                edit: "Edit selections",
            },
            apply: {
                button: "Select slate",
                buttonLabel: "Select slate {{slate}}",
                applied: "{{slate}} selected. You can still change any candidate.",
                appliedPartial_one: "{{slate}} selected. It has no candidate for {{offices}}, so that office is blank. You can still change any candidate.",
                appliedPartial_other: "{{slate}} selected. It has no candidate for {{offices}}, so those offices are blank. You can still change any candidate.",
                overMaximum: "{{slate}} cannot be selected: it has {{candidates}} candidates for {{contest}}, which allows {{max}}. You can still choose candidates individually.",
                unavailable: "{{slate}} cannot be selected on this ballot. You can still choose candidates individually.",
                replaceDialog: {
                    title: "Replace these selections?",
                    content_one: "Selecting <strong>{{slate}}</strong> will change the following office.",
                    content_other: "Selecting <strong>{{slate}}</strong> will change the following offices.",
                    current: "Current selections",
                    blankNote: "{{slate}} has no candidate for some offices. Those offices will be blank.",
                    ok: "Replace selections",
                    okOffice: "Replace {{office}}",
                    cancel: "Keep my selections",
                },
            },
            clear: {
                cleared: "All your choices have been cleared.",
                dialog: {
                    title: "Clear all your choices?",
                    content: "Clearing removes every choice on your ballot. These offices change:",
                    after: "After clearing",
                    ok: "Clear choices",
                    cancel: "Keep my choices",
                },
            },
            offices: {
                label: "Offices",
                picker: "Office",
                index: "Office {{index}} of {{total}}",
                count: "{{selected}}/{{max}}",
                previous: "Previous office",
                next: "Next office",
                last: "Last office",
                instruction_one: "Select up to {{count}} candidate. {{selected}} selected.",
                instruction_other: "Select up to {{count}} candidates. {{selected}} selected.",
            },
            limit: "You can select up to {{count}}. Deselect a candidate before choosing another.",
            view: {
                button: "View slate",
                buttonLabel: "View slate {{slate}}",
                summary: "{{coverage}} · {{candidates}}",
                select: "Select this slate",
                back: "Back",
            },
            dialog: {
                close: "Close dialog",
            },
            clearContest: {
                button: "Clear",
                label: "Clear {{contest}}",
                cleared: "Selections cleared for {{contest}}.",
            },
        },
        ballotLocator: {
            title: "Find your Ballot",
            titleResult: "Your Ballot Lookup Results",
            description: "Confirm your ballot was cast correctly",
            locate: "Find your Ballot",
            locateAgain: "Find another Ballot",
            found: "Your ballot ID {{ballotId}} has been found",
            notFound: "Your ballot ID {{ballotId}} was not found",
            ambiguous: "More than one of your ballots matches {{ballotId}}. Use the full ballot ID.",
            contentDesc: "This is your Ballot content: ",
            wrongFormatBallotId: "Wrong format for Ballot ID",
            ballotIdNotFoundAtFilter: "Not found, check that your Ballot ID is correct and belongs to this user.",
            filterByBallotId: "Filter by Ballot ID",
            totalBallots: "Total Ballots: {{total}}",
            steps: {
                lookup: "Locate your Ballot",
                result: "Result",
            },
            titleHelpDialog: {
                title: "Information: Ballot Locator screen",
                content: "This screen allows you to find your vote by using the Ballot ID to retrieve it. This procedure enables you to check that your ballot was correctly cast and that the recorded ballot matches the encrypted ballot you sent.",
                ok: "OK",
            },
            tabs: {
                logs: "Logs",
                ballotLocator: "Ballot Locator",
            },
            column: {
                statement_kind: "Statement kind",
                statement_timestamp: "Statement Timestamp",
                username: "Username",
                ballot_id: "Ballot ID",
                message: "Message",
            },
            pagination: {
                rowsPerPage: "Rows per page:",
                displayedRows: "{{from}}–{{to}} of {{total}}",
                displayedRowsMoreThan: "{{from}}–{{to}} of more than {{to}}",
                firstPage: "Go to first page",
                lastPage: "Go to last page",
                nextPage: "Go to next page",
                previousPage: "Go to previous page",
            },
        },
    },
};
export default englishTranslation;
